import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

import DemandTable from './components/DemandTable';
import DemandDetailPanel from './components/DemandDetailPanel';
import DemandFilters from './components/DemandFilters';
import BulkActionBar from './components/BulkActionBar';

const DemandManagement = () => {
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(new Date());
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedDemand, setSelectedDemand] = useState(null);
  const [selectedDemands, setSelectedDemands] = useState([]);
  const [filters, setFilters] = useState({
    status: 'all',
    client: 'all',
    priority: 'all',
    dateRange: 'all'
  });
  const navigate = useNavigate();

  // Mock data for demands
  const demandsData = [
    {
      id: 1,
      code: 'DEM-2024-001',
      client: {
        name: 'TechCorp Brasil',
        avatar: 'https://ui-avatars.com/api/?name=TechCorp+Brasil&background=3b82f6&color=fff',
        contact: 'João Silva',
        email: 'joao.silva@techcorp.com.br',
        phone: '+55 11 98765-4321'
      },
      requestType: 'Manutenção Preventiva',
      title: 'Manutenção preventiva do servidor principal',
      description: 'Necessário realizar manutenção preventiva no servidor principal para evitar possíveis falhas. Inclui verificação de hardware, limpeza e atualização de drivers.',
      submissionDate: '28/11/2024',
      priority: 'Alta',
      status: 'Pendente',
      assignedTechnician: null,
      slaDeadline: '05/12/2024',
      attachments: [
        { name: 'especificacoes.pdf', size: '2.4 MB', type: 'application/pdf' }
      ],
      history: [
        {
          date: '28/11/2024 14:30',
          action: 'Demanda criada',
          user: 'João Silva',
          type: 'creation'
        }
      ]
    },
    {
      id: 2,
      code: 'DEM-2024-002',
      client: {
        name: 'Banco Digital SA',
        avatar: 'https://ui-avatars.com/api/?name=Banco+Digital+SA&background=10b981&color=fff',
        contact: 'Maria Santos',
        email: 'maria.santos@bancodigital.com',
        phone: '+55 11 91234-5678'
      },
      requestType: 'Instalação',
      title: 'Instalação de novo sistema de backup',
      description: 'Solicitação para instalação e configuração de sistema de backup automatizado para proteção de dados críticos da empresa.',
      submissionDate: '29/11/2024',
      priority: 'Média',
      status: 'Em Análise',
      assignedTechnician: {
        name: 'Carlos Mendes',
        avatar: 'https://ui-avatars.com/api/?name=Carlos+Mendes&background=8b5cf6&color=fff',
        availability: 'Disponível'
      },
      slaDeadline: '10/12/2024',
      attachments: [
        { name: 'requisitos.docx', size: '1.8 MB', type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
        { name: 'diagrama.png', size: '856 KB', type: 'image/png' }
      ],
      history: [
        {
          date: '29/11/2024 09:15',
          action: 'Demanda criada',
          user: 'Maria Santos',
          type: 'creation'
        },
        {
          date: '29/11/2024 10:45',
          action: 'Atribuída a Carlos Mendes',
          user: 'Admin',
          type: 'assignment'
        }
      ]
    },
    {
      id: 3,
      code: 'DEM-2024-003',
      client: {
        name: 'HealthTech Solutions',
        avatar: 'https://ui-avatars.com/api/?name=HealthTech+Solutions&background=f59e0b&color=fff',
        contact: 'Ana Oliveira',
        email: 'ana.oliveira@healthtech.com',
        phone: '+55 21 99876-5432'
      },
      requestType: 'Suporte Técnico',
      title: 'Suporte técnico para migração de dados',
      description: 'Assistência técnica necessária para migração segura de dados do sistema legado para a nova plataforma implementada.',
      submissionDate: '30/11/2024',
      priority: 'Alta',
      status: 'Aprovado',
      assignedTechnician: {
        name: 'Pedro Costa',
        avatar: 'https://ui-avatars.com/api/?name=Pedro+Costa&background=ec4899&color=fff',
        availability: 'Em atendimento'
      },
      slaDeadline: '07/12/2024',
      attachments: [],
      history: [
        {
          date: '30/11/2024 11:20',
          action: 'Demanda criada',
          user: 'Ana Oliveira',
          type: 'creation'
        },
        {
          date: '30/11/2024 14:00',
          action: 'Aprovada',
          user: 'Admin',
          type: 'approval'
        },
        {
          date: '01/12/2024 09:00',
          action: 'Atribuída a Pedro Costa',
          user: 'Admin',
          type: 'assignment'
        }
      ]
    },
    {
      id: 4,
      code: 'DEM-2024-004',
      client: {
        name: 'Indústria XYZ Ltda',
        avatar: 'https://ui-avatars.com/api/?name=Industria+XYZ&background=6366f1&color=fff',
        contact: 'Roberto Lima',
        email: 'roberto.lima@industriaxyz.com',
        phone: '+55 19 98765-1234'
      },
      requestType: 'Consultoria',
      title: 'Consultoria para otimização de processos',
      description: 'Análise e consultoria para otimização dos processos internos de TI, visando maior eficiência operacional.',
      submissionDate: '01/12/2024',
      priority: 'Baixa',
      status: 'Rejeitado',
      assignedTechnician: null,
      slaDeadline: null,
      rejectionReason: 'Falta de documentação técnica adequada. Cliente deve fornecer mais detalhes sobre os processos atuais.',
      attachments: [],
      history: [
        {
          date: '01/12/2024 15:45',
          action: 'Demanda criada',
          user: 'Roberto Lima',
          type: 'creation'
        },
        {
          date: '02/12/2024 10:30',
          action: 'Rejeitada',
          user: 'Admin',
          type: 'rejection',
          note: 'Falta de documentação técnica adequada'
        }
      ]
    },
    {
      id: 5,
      code: 'DEM-2024-005',
      client: {
        name: 'Varejo Connect',
        avatar: 'https://ui-avatars.com/api/?name=Varejo+Connect&background=14b8a6&color=fff',
        contact: 'Lucia Ferreira',
        email: 'lucia.ferreira@varejoconnect.com',
        phone: '+55 11 97654-3210'
      },
      requestType: 'Manutenção Corretiva',
      title: 'Correção de falha no sistema de pagamentos',
      description: 'Sistema de pagamentos apresentando falhas intermitentes. Necessário correção urgente.',
      submissionDate: '03/12/2024',
      priority: 'Crítica',
      status: 'Pendente',
      assignedTechnician: null,
      slaDeadline: '04/12/2024',
      attachments: [
        { name: 'logs-erro.txt', size: '456 KB', type: 'text/plain' }
      ],
      history: [
        {
          date: '03/12/2024 16:20',
          action: 'Demanda criada',
          user: 'Lucia Ferreira',
          type: 'creation'
        }
      ]
    }
  ];

  // Available technicians
  const availableTechnicians = [
    { id: 1, name: 'Carlos Mendes', availability: 'Disponível', workload: 2 },
    { id: 2, name: 'Pedro Costa', availability: 'Em atendimento', workload: 5 },
    { id: 3, name: 'Ana Paula', availability: 'Disponível', workload: 1 },
    { id: 4, name: 'Ricardo Santos', availability: 'Férias', workload: 0 }
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setLastUpdate(new Date());
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleRefresh = async () => {
    setRefreshing(true);
    await new Promise(resolve => setTimeout(resolve, 1000));
    setLastUpdate(new Date());
    setRefreshing(false);
  };

  const handleSelectDemand = (demand) => {
    setSelectedDemand(demand);
  };

  const handleToggleSelect = (demandId) => {
    setSelectedDemands(prev => 
      prev?.includes(demandId) 
        ? prev?.filter(id => id !== demandId)
        : [...prev, demandId]
    );
  };

  const handleSelectAll = (demands) => {
    if (selectedDemands?.length === demands?.length) {
      setSelectedDemands([]);
    } else {
      setSelectedDemands(demands?.map(d => d?.id));
    }
  };

  const handleApproveDemand = (demandId) => {
    console.log('Approving demand:', demandId);
    // Implement approval logic
  };

  const handleRejectDemand = (demandId, reason) => {
    console.log('Rejecting demand:', demandId, 'Reason:', reason);
    // Implement rejection logic
  };

  const handleAssignTechnician = (demandId, technicianId) => {
    console.log('Assigning technician:', technicianId, 'to demand:', demandId);
    // Implement assignment logic
  };

  const handleBulkAction = (action) => {
    console.log('Bulk action:', action, 'for demands:', selectedDemands);
    // Implement bulk actions
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleToggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleCreateProject = (demandId) => {
    console.log('Creating project from demand:', demandId);
    navigate('/project-management');
  };

  const handleSendMessage = (demandId, message) => {
    console.log('Sending message to demand:', demandId, message);
    // Implement messaging logic
  };

  // Apply filters
  const filteredDemands = demandsData?.filter(demand => {
    if (filters?.status !== 'all' && demand?.status !== filters?.status) return false;
    if (filters?.client !== 'all' && demand?.client?.name !== filters?.client) return false;
    if (filters?.priority !== 'all' && demand?.priority !== filters?.priority) return false;
    return true;
  });

  // Stats
  const stats = {
    total: demandsData?.length || 0,
    pending: demandsData?.filter(d => d?.status === 'Pendente')?.length || 0,
    inAnalysis: demandsData?.filter(d => d?.status === 'Em Análise')?.length || 0,
    approved: demandsData?.filter(d => d?.status === 'Aprovado')?.length || 0,
    rejected: demandsData?.filter(d => d?.status === 'Rejeitado')?.length || 0
  };

  return (
    <div className="min-h-screen bg-background">
      <Header onToggleSidebar={handleToggleSidebar} />
      <main className="container mx-auto px-4 py-8 max-w-7xl">
        {/* Page Header */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-foreground mb-2">
              Gestão de Demandas
            </h1>
            <p className="text-muted-foreground">
              Processamento, priorização e acompanhamento de solicitações de clientes
            </p>
          </div>
          
          <div className="flex items-center space-x-4 mt-4 lg:mt-0">
            <div className="flex items-center space-x-2 text-sm text-muted-foreground">
              <Icon name="Clock" size={16} />
              <span>Atualizado: {lastUpdate?.toLocaleTimeString('pt-BR')}</span>
            </div>
            <Button
              variant="outline"
              iconName="RefreshCw"
              iconPosition="left"
              loading={refreshing}
              onClick={handleRefresh}
            >
              Atualizar
            </Button>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
          <div className="bg-card rounded-lg p-4 border border-border">
            <div className="text-sm text-muted-foreground mb-1">Total</div>
            <div className="text-2xl font-bold text-foreground">{stats?.total}</div>
          </div>
          <div className="bg-card rounded-lg p-4 border border-border">
            <div className="text-sm text-warning mb-1">Pendentes</div>
            <div className="text-2xl font-bold text-warning">{stats?.pending}</div>
          </div>
          <div className="bg-card rounded-lg p-4 border border-border">
            <div className="text-sm text-primary mb-1">Em Análise</div>
            <div className="text-2xl font-bold text-primary">{stats?.inAnalysis}</div>
          </div>
          <div className="bg-card rounded-lg p-4 border border-border">
            <div className="text-sm text-success mb-1">Aprovados</div>
            <div className="text-2xl font-bold text-success">{stats?.approved}</div>
          </div>
          <div className="bg-card rounded-lg p-4 border border-border">
            <div className="text-sm text-error mb-1">Rejeitados</div>
            <div className="text-2xl font-bold text-error">{stats?.rejected}</div>
          </div>
        </div>

        {/* Filters */}
        <DemandFilters
          filters={filters}
          onFilterChange={handleFilterChange}
          clients={[...new Set(demandsData?.map(d => d?.client?.name))]}
        />

        {/* Bulk Actions Bar */}
        {selectedDemands?.length > 0 && (
          <BulkActionBar
            selectedCount={selectedDemands?.length}
            onBulkApprove={() => handleBulkAction('approve')}
            onBulkReject={() => handleBulkAction('reject')}
            onBulkAssign={() => handleBulkAction('assign')}
            onClearSelection={() => setSelectedDemands([])}
          />
        )}

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Demand Table */}
          <div className="lg:col-span-2">
            <DemandTable
              demands={filteredDemands}
              loading={loading}
              selectedDemands={selectedDemands}
              onSelectDemand={handleSelectDemand}
              onToggleSelect={handleToggleSelect}
              onSelectAll={() => handleSelectAll(filteredDemands)}
            />
          </div>

          {/* Detail Panel */}
          <div className="lg:col-span-1">
            <DemandDetailPanel
              demand={selectedDemand}
              technicians={availableTechnicians}
              onApprove={handleApproveDemand}
              onReject={handleRejectDemand}
              onAssignTechnician={handleAssignTechnician}
              onCreateProject={handleCreateProject}
              onSendMessage={handleSendMessage}
            />
          </div>
        </div>

        {/* Mobile Bottom Spacing */}
        <div className="h-20 lg:hidden"></div>
      </main>
    </div>
  );
};

export default DemandManagement;